export default __webpack_public_path__ + "static/media/PPI-patio-003.1c90963a.jpg";